import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class AppLoadingService{

    private appLoading = new BehaviorSubject<any>([]);
    appLoading$ = this.appLoading.asObservable();

    private pool = [];

    async setLoaded(v,local){
        if(typeof this.pool[local] != 'undefined' && this.pool[local] == v)
            return;

        this.pool[local] = v;
        await this.appLoading.next(this.pool);
    }

    isAllLoaded(){
        return Object.keys(this.pool).filter(item => this.pool[item] == true).length ==  Object.keys(this.pool).length;
    }
    isLoaded(local){
        return typeof this.pool[local] === 'undefined'? null : this.pool[local];
    }
}